export const areObjectDifferent = (object1: any, object2: any, attributeToCompareList: string[]) => {
    let isDifferent = false;
    for (const attribute of attributeToCompareList) {
        if (object1[attribute] !== object2[attribute]) {
            isDifferent = true;
        }
    }
    return isDifferent;
}